var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 6.917q.084 0 .165.015l.03.005.045.01.048.012q.075.023.144.058.023.01.042.02a1 1 0 0 1 .482.587q.008.03.015.062.028.111.029.231v10a1 1 0 1 1-2 0v-7.586l-8.293 8.293a1 1 0 1 1-1.414-1.414l8.293-8.293H7a1 1 0 1 1 0-2z"
  })));
};
export default Svg24;